import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import BinaryRain from "./BinaryRain";
import HackerWatch from "./HackerWatch";
import { useEffects } from "../contexts/SettingsContext";

export default function Layout() {
  const { effects } = useEffects();

  return (
    <div className="flex min-h-screen flex-col bg-ds-bg font-sans text-ds-text">
      {effects.binaryRain && <BinaryRain />}
      <Navbar />
      <main className="relative z-10 flex-1 pt-16">
        <Outlet />
      </main>
      {effects.surveillance && (
        <HackerWatch videoUrl={effects.videoUrl} />
      )}
      <footer className="relative z-10 border-t border-ds-border py-6 text-center">
        <p className="text-xs text-ds-text-muted">
          CyberSentinel Academy &copy; {new Date().getFullYear()}
        </p>
        <p className="text-[10px] text-ds-text-muted/60">
          CyberSec PRN 2026 FZCO
        </p>
      </footer>
    </div>
  );
}
